import React, { useEffect, useRef } from 'react';
import { InputField } from '../../../../../../Form';
import { IOperandValue } from '../../../../../types';
import { createBasicFieldValue } from '../../../../../utils/createBasicFieldValue';

interface IProps {
  value: string;
  onChange: (newValue: IOperandValue | null) => void;
  placeholder: string;
  autoFocus?: boolean;
  disabled?: boolean;
  hasError?: boolean;
}

const OperandTextInput = ({
  value,
  onChange,
  placeholder,
  autoFocus,
  disabled,
  hasError,
}: IProps) => {
  const ref = useRef<HTMLInputElement>(null);

  const onTextValueChangeHandler = (newValue: string) => {
    onChange(newValue ? createBasicFieldValue(newValue) : null);
  };
  useEffect(() => {
    if (!disabled && autoFocus) {
      ref?.current?.focus();
    }
  }, [autoFocus, disabled]);

  return (
    <InputField
      ref={ref}
      value={value}
      onChange={onTextValueChangeHandler}
      placeholder={placeholder}
      hasError={hasError}
    />
  );
};

export default OperandTextInput;
